const Content = {
  'services': {
    'body1': 'Some agencies specialize in qual, others focus on quant - but we connect the two disciplines with hybrid teams expert in both modalities. We\'re a one-stop, custom consultancy that tailors our approach to solve your biggest challenges. Don\'t see what you need?',
    'body2': '',
    'anchorHref': 'mailto:inquiry@nrgmr.com',
    'anchorText': 'Ask us.',
    'signOff': 'We can do it.',
  },
  'network': {
    'body1': 'Like what you see? Have a problem you can\'t quite figure out?',
    'body2': 'Give us a call or',
    'anchorHref': 'mailto:inquiry@nrgmr.com',
    'anchorText': 'drop us a line,',
    'signOff': 'anytime.'
  },
  'people': {
    'body1': 'Our business is driven by creative, curious and inventive people who have a deep passion for pop culture and storytelling.',
    'body2': 'We work as a collective across disciplines, methodologies and geographies to bring together the best teams and thinking for every assignment.'
  }
};

export { Content };
